export const LensProductAvailabilityEnum = Object.freeze({
  READY: "READY",
  PRE_ORDER: "PRE_ORDER",
});
